// src/pages/NotFound/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css'; // Opcional, para estilos específicos

const NotFound = () => {
  return (
    <div className="not-found-container">
      <h1>404</h1>
      <p>Lo sentimos, la página que buscas no existe.</p>
      <Link to="/" className="back-home-link">Volver al Inicio</Link>
    </div>
  );
};

export default NotFound;